module.exports = __webpack_public_path__ + "img/sarre-mini-NB.99bf2cad.gif";